import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

export default new Router({
    mode: 'history',
    routes: [
        {
            path: '/',
            name: 'Home',
            component: require('@/components/home').default
        }, {
            path: '/top-destinations',
            name: 'TopDestinations',
            component: require('@/components/topDestinations').default
        }, {
            path: '/explore-itineraries',
            name: 'ExploreItineraries',
            component: require('@/components/exploreItineraries').default
        }, {
            path: '/privacy-policy',
            name: 'PrivacyPolicy',
            component: require('@/components/privacyPolicy').default
        }, {
            path: '/terms-and-conditions',
            name: 'Terms',
            component: require('@/components/terms').default
        }, {
            path: '/itinerary',
            name: 'ItineraryDisplay',
            component: require('@/components/itineraryDisplay').default
        }, {
            path: '/about',
            name: 'About',
            component: require('@/components/about').default
        }, {
            path: '/faq',
            name: 'FAQ',
            component: require('@/components/faq').default
        }, {
            path: '/contact-us',
            name: 'ContactUs',
            component: require('@/components/contactUs').default
        }, {
            path: '/create-itinerary',
            name: 'CreateItinerary',
            component: require('@/components/createItinerary').default
        }, {
            path: '/profile',
            name: 'Profile',
            component: require('@/components/profile').default,
            props: { isUser: false }
        }, {
            path: '/my-profile',
            name: 'MyProfile',
            component: require('@/components/profile').default,
            props: { isUser: true }
        }, {
            path: '/edit-profile',
            name: 'EditProfile',
            component: require('@/components/editProfile').default
        }
    ],
    scrollBehavior () {
        return { x: 0, y: 0 }
    }
})
